export interface ApiStatusCounters {
    queeuStatus: string;
    signContractSucceeded: number;
    signContractFailed: number;
    loginSucceeded: number;
    loginFailed: number;
    templateSucceeded: number;
    templateFailed: number;
    synchronizeRequestSucceeded: number;
    synchronizeRequestFailed: number;
    responseSucceeded: number;
    responseFailed: number;
    synchronizeFailed: number;
}

export interface AppServiceState {
    processingCount: number;
    status: ProcessStatus;
}

// ── Tilstand (GET /synccenter/state) ────────────────────────────────────────

export interface SyncStateDto {
    generatedAt: string;
    environment: string | null;
    note: string | null;
    pool: SyncPoolDto;
    services: SyncServiceDto[];
    runs: SyncRunDto[];
    stranded: SyncRunDto[];
}

export interface SyncPoolDto {
    name: string | null;
    /** "running" | "paused" | "unknown" | "processstatus-N" as the Sync API spells it. */
    state: string;
    queued: number;
    processing: number;
    paused: number;
    error: string | null;
    note: string | null;
    /** Every pool row, oldest first. */
    items: SyncPoolRowDto[];
}

export interface SyncPoolRowDto {
    /** customerId_companyId_tableGroupId — one in-flight kørsel per partition. */
    partitionKey: string;
    queueId: string;
    queueName: string;
    /** "queued" | "processing" | "paused" */
    status: string;
    added: string;
    attemptCount: number;
    customerId: number | null;
    companyId: number | null;
    tableGroupId: string | null;
}

export interface SyncServiceDto {
    role: string;
    /** Base URL; the status hub is at `${url}/statushub`. Null when the row has none. */
    url: string | null;
    /** Stop/start can be sent: a worker with a Url and an AdminKey. Never true for the Api. */
    canControl: boolean;
}

export type SyncServiceAction = 'stop' | 'start' | 'state';

/** What a worker answered to /admin/stop, /admin/start or /admin/state. */
export interface SyncServiceCommandResultDto {
    role: string;
    /** The worker's ProcessStatus after the command: Running, Stopping, Stopped, … */
    status: string;
    processingCount: number;
}

export interface SyncRunDto {
    id: string;
    customerId: number;
    companyId: number;
    synchronizationId: string;
    synchronizationName: string | null;
    action: string;
    task: string;
    templateId: string;
    description: string;
    status: number | null;
    created: string | null;
    lastActivity: string | null;
    executers: SyncExecuterCountsDto;
}

export interface SyncExecuterCountsDto {
    total: number;
    waiting: number;
    executing: number;
    postSynchronizationQueued: number;
    done: number;
    failed: number;
    other: number;
}

/** What a service's status hub last told us. */
export interface ServiceLiveState {
    lastSeen: Date;
    processingCount: number | null;
    status: ProcessStatus | null;
    /** The Api hub sends ApiStatusCounters; its queue state is the pool's, as the API sees it. */
    queueState: string | null;
}

export enum ProcessStatus {
    Unset = 0,
    Starting = 1,
    Running = 2,
    InAction = 3,
    Stopping = 4,
    Stopped = 5,
    Pauseing = 6,
    Paused = 7
}
